import { ApiAuthRepository } from '../infrastructure/repositories/ApiAuthRepository';
import { AuthDomainService } from '../domain/services/AuthDomainService';
import { AuthService } from '../application/AuthService';
import { AuthUseCase } from '../domain/usecases/AuthUseCase';
import { StorageService } from '../infrastructure/StorageService';
import { TokenRepository } from '../infrastructure/repositories/TokenRepository';
import { TokenService } from '../application/services/TokenService';
import { UserCredentialsService } from '../application/UserCredentialsService';
import { setupAxiosAuthInterceptors } from '../infrastructure/AxiosAuthInterceptor';
import axiosServices from '@/common/infrastructure/axios';

/**
 * Dependency injection container for auth module
 * Creates and wires together all services according to clean architecture
 */
class AuthDependencyContainer {
  // Domain layer
  readonly authDomainService = new AuthDomainService();

  // Infrastructure layer - repositories
  readonly tokenRepository = new TokenRepository();
  readonly storageService = new StorageService();

  // Application layer - services
  readonly tokenService = new TokenService(this.tokenRepository, this.authDomainService);
  readonly userCredentialsService = new UserCredentialsService(this.storageService);

  // Domain layer - repositories and use cases
  readonly authRepository = new ApiAuthRepository(this.tokenService);
  readonly authUseCase = new AuthUseCase(this.authRepository, this.authDomainService);

  // Application layer - main application service
  readonly authService = new AuthService(this.authUseCase, this.userCredentialsService);

  constructor() {
    // Initialize auth interceptors on the axiosServices instance
    setupAxiosAuthInterceptors(this.tokenService, axiosServices);
  }
}

// Create a singleton instance
const authServices = new AuthDependencyContainer();

export default authServices;
